/* eslint-disable import/prefer-default-export */
export const typography = {
  // Montserrat - Semibold (600)
  montSemiboldHero: { fontFamily: 'Montserrat', fontSize: { xs: 32, md: 44, lg: 56 }, fontWeight: 600, lineHeight: { xs: '40px', md: '54px', lg: '68px' } },
  montSemibold28: { fontFamily: 'Montserrat', fontSize: 28, fontWeight: 600, lineHeight: '40px' },
  montSemibold24: { fontFamily: 'Montserrat', fontSize: 24, fontWeight: 600, lineHeight: '32px' },
  montSemibold20: { fontFamily: 'Montserrat', fontSize: 20, fontWeight: 600, lineHeight: '24px' },
  montSemibold16: { fontFamily: 'Montserrat', fontSize: 16, fontWeight: 600, lineHeight: '22px' },
  
  // Lato - Semibold (600)
  latoSemibold14: { fontFamily: 'Lato', fontSize: 14, fontWeight: 600, lineHeight: '26px' },
  latoSemibold16: { fontFamily: 'Lato', fontSize: 16, fontWeight: 600, lineHeight: '100%' },
  
  // Lato - Regular (400)
  latoSemibold28: { fontFamily: 'Lato', fontSize: 28, fontWeight: 600, lineHeight: '40px' },
  latoRegular18: { fontFamily: 'Lato', fontSize: 18, fontWeight: 400, lineHeight: '26px' },
  latoRegular16: { fontFamily: 'Lato', fontSize: 16, fontWeight: 400, lineHeight: '20px' },
  latoRegular16Alt: { fontFamily: 'Lato', fontSize: 16, fontWeight: 400, lineHeight: '26px' },
  latoRegular14: { fontFamily: 'Lato', fontSize: 14, fontWeight: 400, lineHeight: '20px' },
  latoRegular14Alt: { fontFamily: 'Lato', fontSize: 14, fontWeight: 400, lineHeight: '24px' },
  
  // Lato - Medium (500)
  latoMedium14: { fontFamily: 'Lato', fontSize: 14, fontWeight: 500, lineHeight: '20px' },
  
  // Lato - Bold (700)
  latoBold16: { fontFamily: 'Lato', fontSize: 16, fontWeight: 700, lineHeight: '24px' },
  latoBold18: { fontFamily: 'Lato', fontSize: 18, fontWeight: 700, lineHeight: '24px' },
};
